module.exports = {
      id: "marginnote-banner-left-usage",
      viewBox: "0 0 500 250",
      url: __webpack_public_path__ + "images/js_src_vue/page_marginnote_landing/sprite.20f12c2e.svg#marginnote-banner-left-usage",
      toString: function () {
        return this.url;
      }
    }